import { Logo } from "@/components/brand/Logo";
import { cn } from "@/lib/utils";

interface SidebarHeaderProps {
  isCollapsed: boolean;
  toggleSidebar: () => void;
  isMobile: boolean;
}

/**
 * Sidebar Header.
 */
export function SidebarHeader({ isCollapsed, isMobile }: Readonly<SidebarHeaderProps>) {
  return (
    <div
      className={cn(
        "flex items-center bg-background border-b border-border",
        isMobile ? "py-4 px-6" : "py-4 px-5",
        isCollapsed && !isMobile ? "justify-center" : "justify-start"
      )}
    >
      {/* Logo only - no icon */}
      <div className="animate-fade-in">
        <Logo
          mini={isCollapsed && !isMobile}
          showText={!isCollapsed || isMobile}
          linkToHome={false}
          className="text-primary"
          useImageLogo={false}
        />
      </div>
    </div>
  );
}
